//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentProcessorDisplayItem } from './PaymentProcessorDisplayItem';
import { PaymentSurchargeDisplayItem } from './PaymentSurchargeDisplayItem';

export class SchoolPaymentSettingsDisplayItem extends ItemBase {
    DefaultPaymentProcessor: PaymentProcessorDisplayItem | null = null;
    AutoPaySupported: boolean = false;
    ForceAutoPay: boolean = false;
    PaymentSourceRequired: boolean = false;
    CurrencyCode: string | null = null;
    PaymentProcessorFeeCashCategoryID: string | null = null;
    PaymentSurchargeACH: PaymentSurchargeDisplayItem | null = null;
    PaymentSurchargeCreditCard: PaymentSurchargeDisplayItem | null = null;
    SendAutomaticEmailReceipt: boolean = false;
    SendAutomaticSMSReceipt: boolean = false;

    constructor(initializer?: Partial<SchoolPaymentSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolPaymentSettingsDisplayItem";
}
